import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import RADApplication from '@/Management/RADApplication';

/**
* Methode zum loggen einer Nachricht
*/
export function logMessage(level: number, message: string, location: string) {
    if (location != null) {
        message = 'Location: ' + location + '\n' + message;
    }

    write(level, message);
}

/**
    * Methode zum loggen eines Fehlers
    */
export function logError(level: number, error, location: string) {
    let message: string | void;
    message = getErrorInformation(error);

    if (location != null) {
        message = 'Location: ' + location + '\n' + message;
    }

    write(level, message);
}

/**
* Objekt mit vorhandenen Log-Levels
*/
export let LogLevel = {
    Debug: 0,
    Info: 1,
    Warn: 2,
    Error: 3,
    Fatal: 4
}

/**
    * Methode zum Auslesen des aktuellen Benutzernamen
    */
function getCurrentUserName() {
    if (RADApplication.getInstance().user != null && RADApplication.getInstance().user.isLoggedIn()) {
        return RADApplication.getInstance().user.username();
    }

    return null;
}

/**
* Liefert Informationen zu einem aufgetretenen Fehler
*/
function getErrorInformation(error) {
    let stack = error.stack;
    return 'Message: ' + error.message + '\n' + stack;
}

/**
* Schreibt eine Nachricht in die Konsole und übermittelt sie an den Server
*/
function write(level, message) {
    let username = getCurrentUserName();

    if (username != null) {
        message += '\n' + 'User: ' + username;
    }

    const loggingMethod = getLoggingMethod(level);
    loggingMethod(`RADClient => ${message}`);

    RADEnvironmentProxy.getInstance().outputMessage({
        message: message,
        priority: level
    });
} 

function getLoggingMethod(level: number): (message: string) => void {
    switch (level) {
        case LogLevel.Debug:
            return console.debug;
        case LogLevel.Error:
        case LogLevel.Fatal:
            return console.error;
        case LogLevel.Info:
            return console.info;
        case LogLevel.Warn:
            return console.warn;
        default:
            return console.log;
    }
}

export default {
    LogLevel,
    logError,
    logMessage
}